import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const FAQ = () => {
  const faqs = [
    {
      question: "What character limits are on a Fornite name?",
      answer:
        "In Fortnite, your Epic Games display name, which is also your in-game nickname, must be between 3 and 16 characters long.",
    },
    {
      question: "Are there any Epic Games Content Resrictions?",
      answer:
        "Your display name cannot contain vulgarity, hate speech, offensive or derogatory language, or direct references to any Epic Games employee, product, service, or character.",
    },
    {
      question: "Where do I go to change my Account name?",
      answer:
        "You can change your Epic Games display name on the Epic Games website by going to your account settings and clicking on the pencil icon next to your current display name.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-100 py-10">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white shadow rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex justify-between items-center px-4 py-3 text-left text-gray-800 font-medium focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`h-6 w-6 transform ${
                    openIndex === index ? "rotate-180" : ""
                  } transition-transform duration-300`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {openIndex === index && (
                <div className="px-4 py-3 text-gray-600 bg-gray-50">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
